export const enum LuckyWheelOfferType {
    OFFER = 'OFFER',
    NO_OFFER = 'NO_OFFER',
    SPIN = 'SPIN'
}

export const enum LuckyWheelActionType {
    ACCEPT = 'ACCEPT',
    DECLINE = 'DECLINE',
    DELAY = 'DELAY'
}

export const enum LuckyWheelWinType {
    WIN = 'WIN',
    LOST = 'LOST',
    REPEAT = 'REPEAT'
}
